
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';

const { exchanger } = api;

@Component({
  components: { },
})
export default class VirtualExchangerList extends Vue {
  private data = { data: [] };

  private headers = [
    { text: '名稱', value: 'name' },
    { text: '交易所LOGO', value: 'pic', width: 100 },
    { text: '最低手續費', value: 'serviceFee' },
    { text: '手續費百分比', value: 'serviceFeePercentage' },
    { text: '開放交易', value: 'isTradable' },
    { text: '修改', value: 'edit' },
    { text: '啟用', value: 'enable' },
    { text: '查看貨幣', value: 'currency' },
  ];

  private get collection() {
    return [...(this.data.data || [])];
  }

  private async handleEditEnable(exchangerId: string, isEnabled: boolean) {
    const message = isEnabled ? '停用' : '啟用';
    await Swal.fire(
      {
        title: `您確定要${message}嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await exchanger.modifyStatus(exchangerId, !isEnabled);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: `${message}成功` });
          await this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: `${message}失敗，請聯繫系統管理員。` });
        }
      }
    });
  }

  private async requestData() {
    const { data } = await exchanger.list({ pageSize: 0, pageNo: 1 });
    this.data = data;
  }

  private async created() {
    await this.requestData();
  }
}
